import axios from "axios";
import { AXIOS_DEFAULT_CONFIG, routes } from "../../constants";

const rejectRegistration = async (linkId, regId) => {
  const response = await axios.post(
    routes.inviteflowRejectRegistration(linkId, regId),
    {},
    AXIOS_DEFAULT_CONFIG
  );
  return response;
};

export default rejectRegistration;
